import cx from 'classnames';
import React from 'react';
import { Link as LinkRouter, LinkProps } from 'react-router-dom';

interface Props extends LinkProps {
  size?: 'large' | 'medium';
}

export const Link = React.forwardRef<HTMLAnchorElement, Props>(({ size, className, ...rest }, ref) => {
  return <LinkRouter {...rest} ref={ref} className={cx('link', { 'link-medium': size === 'medium' }, className)} />;
});
